// =============================
// eBike Subscription Config (multi-model version)
// =============================

// Deposit variants — link usage type to deposit variant IDs
const depositVariantMap = {
  leisure: 51735654203734,    // £100 deposit
  commuting: 51735654236502,  // £150 deposit
  work: 51735654269270        // £200 deposit
};

// Subscription variant IDs for both bike models
const subscriptionVariantMap = {
  // Wrath 2.0
  wrath_17: 51735549083990,
  wrath_19: 51735549116758,

  // SX300
  sx300_18: 51735545479510,
  sx300_20: 51735545545046
};

// Selling plan IDs from Loop
const sellingPlanMap = {
  wrath: 690514329942,
  sx300: 690514329942
};

// =============================
// Form Handling Logic (visual bike selection)
// =============================
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('ebike-plan-form');
  if (!form) {
    console.warn('⚠️ eBike plan form not found on this page.');
    return;
  }

  const usageButtons = document.querySelectorAll('.usage-btn');
  const showBikesBtn = document.getElementById('show-bikes');
  const bikeStep = document.getElementById('bike-step');
  const bikeOptionsContainer = document.getElementById('bike-options');
  const selectedModelInput = document.getElementById('selected_model');
  const selectedWheelInput = document.getElementById('selected_wheel');
  let selectedUsage = '';

    // ===== Default to Leisure =====
  selectedUsage = 'leisure';

  const leisureBtn = document.querySelector('.usage-btn[data-usage="leisure"]');
  if (leisureBtn) {
    leisureBtn.classList.add('active');
    showBikesBtn.disabled = false;
  }

  // Bike data to display (update image URLs and product links as needed)
  const bikes = [
    {
      model: 'wrath',
      name: 'Wrath 2.0',
      image: 'https://cdn.shopify.com/s/files/1/0898/2465/7750/files/clad-butler-wrath2-main.jpg?v=1741347992',
      link: '/products/wrath-2-0-subscription',
      monthly: 79,
      wheels: [
        { size: '17', label: '17″ Wheel', variantId: 51735549083990 },
        { size: '19', label: '19″ Wheel', variantId: 51735549116758 }
      ]
    },
    {
      model: 'sx300',
      name: 'SX300',
      image: 'https://cdn.shopify.com/s/files/1/0898/2465/7750/files/ecobike-sx300-sandstorm-main.jpg?v=1741356481',
      link: '/products/sx300-subscription',
      monthly: 99,
      wheels: [
        { size: '18', label: '18″ Wheel', variantId: 51735545479510 },
        { size: '20', label: '20″ Wheel', variantId: 51735545545046 }
      ]
    }
  ];

  // Handle usage selection buttons
  usageButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      usageButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      selectedUsage = btn.dataset.usage;
      showBikesBtn.disabled = false;
    });
  });

  // Step 1 – Reveal bikes once usage selected
  showBikesBtn.addEventListener('click', () => {
    if (!selectedUsage) {
      alert('Please select how you will use your eBike first.');
      return;
    }

    bikeStep.style.display = 'block';
    showBikesBtn.disabled = true;

    const deposit = {
      leisure: 100,
      commuting: 150,
      work: 200
    }[selectedUsage];

    // Render bike cards
    bikeOptionsContainer.innerHTML = '';
    bikes.forEach(bike => {
      const card = document.createElement('div');
      card.className = 'bike-card';
      card.style.cssText = `
        border:1px solid #ddd;
        border-radius:10px;
        padding:15px;
        width:280px;
        text-align:center;
        cursor:pointer;
        transition:all .2s ease;
        box-shadow:0 0 5px rgba(0,0,0,0.05);
      `;

      card.innerHTML = `
        <img src="${bike.image}" alt="${bike.name}"
             style="width:100%;height:200px;object-fit:cover;border-radius:8px;">
        <h4 style="margin:10px 0;">${bike.name}</h4>
        <p style="margin:4px 0;font-weight:bold;">Deposit: £${deposit}</p>
        <p style="margin:4px 0;color:#555;">Monthly: £${bike.monthly}/mo</p>
        <select style="margin-top:10px;width:100%;padding:6px;">
          <option value="">Choose wheel size</option>
          ${bike.wheels.map(w => `<option value="${w.size}">${w.label}</option>`).join('')}
        </select>
        <a href="${bike.link}" target="_blank" class="button button--secondary" 
           style="display:inline-block;margin-top:10px;padding:8px 16px;">View Details</a>
      `;

      bikeOptionsContainer.appendChild(card);

      // Handle selection click
      const select = card.querySelector('select');
      select.addEventListener('change', () => {
        // remove highlight from all
        document.querySelectorAll('.bike-card').forEach(c => c.style.border = '1px solid #ddd');
        // highlight selected
        card.style.border = '2px solid #000';
        // record selection
        selectedModelInput.value = bike.model;
        selectedWheelInput.value = select.value;
      });
    });
  });

  // Step 2 – Handle form submission
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const model = selectedModelInput.value;
    const wheel = selectedWheelInput.value;
    const usage = selectedUsage;

    if (!model || !wheel || !usage) {
      alert('Please choose your bike and wheel size before continuing.');
      return;
    }

    const depositVariantId = depositVariantMap[usage];
    const subscriptionVariantId = subscriptionVariantMap[`${model}_${wheel}`];
    const subscriptionSellingPlanId = sellingPlanMap[model];

    if (!depositVariantId || !subscriptionVariantId || !subscriptionSellingPlanId) {
      alert('Configuration error – please check your setup.');
      console.error('Missing ID(s):', { depositVariantId, subscriptionVariantId, subscriptionSellingPlanId });
      return;
    }

    const items = [
      { id: depositVariantId, quantity: 1 },
      { id: subscriptionVariantId, quantity: 1, selling_plan: subscriptionSellingPlanId }
    ];

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!res.ok) throw new Error('Cart add failed');
      window.location.href = '/cart';
    } catch (err) {
      console.error('Error adding to cart:', err);
      alert('Something went wrong while adding to your cart.');
    }
  });
});
